var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFinanceAndInsurance = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Saving-Bank-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Saving Bank 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7 12a1 1 0 0 0 0 -2H3a1 1 0 0 0 0 2h0.25a0.25 0.25 0 0 1 0.25 0.25v4a0.25 0.25 0 0 1 -0.25 0.25H3a1 1 0 0 0 0 2h4a1 1 0 0 0 0 -2h-0.25a0.25 0.25 0 0 1 -0.25 -0.25v-4a0.25 0.25 0 0 1 0.25 -0.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 12a1 1 0 0 0 0 -2h-4a1 1 0 0 0 0 2h0.25a0.25 0.25 0 0 1 0.25 0.25v4a0.25 0.25 0 0 1 -0.25 0.25H10a1 1 0 0 0 0 2h4a1 1 0 0 0 0 -2h-0.25a0.25 0.25 0 0 1 -0.25 -0.25v-4a0.25 0.25 0 0 1 0.25 -0.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 12a1 1 0 0 0 0 -2h-4a1 1 0 0 0 0 2h0.25a0.25 0.25 0 0 1 0.25 0.25v4a0.25 0.25 0 0 1 -0.25 0.25h-0.25a1 1 0 0 0 0 2h4a1 1 0 0 0 0 -2h-0.25a0.25 0.25 0 0 1 -0.25 -0.25v-4a0.25 0.25 0 0 1 0.25 -0.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.45 8.5h19.2a1 1 0 0 0 0.93 -0.58 0.88 0.88 0 0 0 -0.31 -1.07L13.14 0.2a1.07 1.07 0 0 0 -1.21 0L1.87 6.83a0.87 0.87 0 0 0 -0.35 1.07 1 1 0 0 0 0.93 0.6Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.92 23.22 -2 -3a0.51 0.51 0 0 0 -0.42 -0.22h-19a0.51 0.51 0 0 0 -0.42 0.22l-2 3A0.5 0.5 0 0 0 0.5 24h23a0.5 0.5 0 0 0 0.42 -0.78Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFinanceAndInsurance);
export default ForwardRef;